import { Image, ImageProps } from 'components'
import { ScaleProps, useScaleProps } from '../../utils/scaleUtils'

export type Props = ScaleProps<ImageProps>

export default function SImage(props: Props) {
  const { styleProps, rest } = useScaleProps(props)

  return <Image {...styleProps} {...rest} />
}
